import { render } from "./parametrizacionleyinciso.vue?vue&type=template&id=0126f67c"
import script from "./parametrizacionleyinciso.vue?vue&type=script&lang=js"
export * from "./parametrizacionleyinciso.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__